import * as Api from '@ViewModels';
import { FC, useCallback } from 'react';
import { NavigationBreadcrumbsBar } from '../../../web/components/NavigationBreadcrumbsBar';

interface BreadcrumbsBarNameProviderProps {
	account: Api.IAccount;
	currentLocation: string;
}

export const BreadcrumbsBarWithNameProvider: FC<BreadcrumbsBarNameProviderProps> = ({ account, currentLocation }) => {
	const appBarHeaderPathComponentNameProvider = useCallback(
		(pathComponent: string) => {
			if (account?.id === pathComponent) {
				return account?.companyName;
			}
			return pathComponent
				? pathComponent
						.split(' ')
						.filter(x => !!x)
						.map(x => `${x.substring(0, 1).toLocaleUpperCase()}${x.substring(1)}`)
						.join(' ')
				: pathComponent;
		},
		[account?.companyName, account?.id]
	);

	return (
		<NavigationBreadcrumbsBar
			currentLocationName={currentLocation}
			pathComponentNameProvider={appBarHeaderPathComponentNameProvider}
		/>
	);
};
